import { useMutation } from "@tanstack/react-query";
import { trainerAccountApi } from "api/trainers/trainerAccountApi";

export const useBulkGenerateTrainerAccount = () => {
  return useMutation({
    mutationFn: (trainerIds: number[]) => trainerAccountApi.bulkGenerateAccount(trainerIds),
  });
};
